import getCurrentUser from '../utils/getCurrentUser'
import isBrowser from '../utils/isBrowser'

const SNAPCHAT_PIXEL_ID = 'e78c52ce-ec96-4e4f-9865-2b1a6406d25b'
export function initializeSnapchatPixel() {
  const user = getCurrentUser()
  if (isBrowser() && window.snaptr) {
    window.snaptr(
      'init',
      SNAPCHAT_PIXEL_ID,
      user?.email
        ? {
            user_email: user.email,
          }
        : undefined,
    )
  }
}
